import React, { useEffect, useState, useContext } from "react";
import DataTable from "../componets/DataTableComponent";
import { NotificacionContext } from "../context/notificacion_context";
import Grid from "@mui/material/Grid";
import { services } from "../services/api";
import { useNavigate } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import IconUI from "../componets/ui/icon_ui";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Tooltip } from "@mui/material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import Button from "@mui/material/Button";

export const ProfesoresView = () => {
  const [checked, setChecked] = React.useState(false);
  const [nombreProfesor, setNombreProfesor] = useState();

  const handleChange = (id) => {
   
    setChecked(true);

    // const selectedItem = state.data[id];

    // const alumnos = selectedItem?.selectedItem?.alumnos || [];

    // setTaller(selectedItem.taller);
    setState(prev => {
      const selectedItem = prev.data[id] || {};
      return {
        ...prev,
        index: id,
        alumnos: selectedItem.alumnos || []
      };
    });


  };





  const navigate = useNavigate();

  const [state, setState] = useState({
    data: [],
    talleres: [],
    alumnos: [],
    loading: true,
    index: 0,
  });

  // const [taller, setTaller] = useState(null);


  const ListasProfesores = async () => {
    try {
      const userInfo = localStorage.getItem("id");
      if (userInfo) {
        const response = await services("GET", `usuarios/showprofesor/${userInfo}`, null);

        setNombreProfesor(response.data[0]?.taller?.profesor);


        setState({
          ...state,
          data: response.data,
          loading: false

        });
      }

    } catch (error) {
      console.error("Error al obtener datos del profesor:", error);
      setState({
        ...state,
        loading: false
      });
    }
  };

  const Descargar = async () => {
    try {
      // Obtener el taller actual usando el index del state
      const selectedItem = state.data[state.index];

      if (!selectedItem || !selectedItem.taller) {
        console.error('No hay taller seleccionado');
        return;
      }

      const { taller } = selectedItem;
     

      const descargarPdf = await services('blob', `usuarios/pdf/curso/${taller.idtpp}/${taller.idprofesor}`);




      const url = window.URL.createObjectURL(new Blob([descargarPdf.data]));
     
      const link = document.createElement('a');
      link.href = url;
      link.download = "alumnos.pdf";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);




    } catch (error) {
      console.error('Error al descargar:', error);
    }
  };



  useEffect(() => {
    if (localStorage.getItem("rol") !== "Profesor") {
      navigate("/");
    } else {
      ListasProfesores();

    }
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  const { showNotification } = useContext(NotificacionContext);
  const columns = [
    {
      name: "nombretaller",
      label: "Taller",
      align: "center",
      options: {
        searchable: true,
        download: true,
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let nombre = `${state.data[dataIndex].taller.nombretaller}`;
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center justify-content-center"
            >
              {nombre}
            </div>
          );
        },
      },
    },

    {
      name: "profesor",
      label: "Profesor",
      options: {
        download: true,
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let Descripcion = state.data[dataIndex].taller.profesor;

          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center justify-content-center"
            >
              {Descripcion}
            </div>
          );
        },
      },
    },

    {
      name: "acciones",
      label: "Acciones",

      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            <div
              style={{ height: "60px" }}
              className="w-100 d-flex justify-content-center align-items-center "
            >
              <Tooltip title="Ver detalles">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    handleChange(dataIndex, state.data[dataIndex].taller);

                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <RemoveRedEyeIcon />
                  </IconUI>
                </div>
              </Tooltip>
            </div>
          </>
        ),
      },
    },
  ];


  const columnsAlumnos = [

    {
      name: "lista",
      label: "N° Lista",
      options: {
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    }
    ,
    {
      name: "CURP",
      label: "Curp",
    },
    {
      name: "apaterno",
      label: "Apellido paterno",
    },
    {
      name: "amaterno",
      label: "Apellido materno",

    },
    {
      name: "nombre",
      label: "Nombre Alumno",
    },
    {
      name: "nombretaller",
      label: "Nombre del Taller",
    },
    {
      name: "asistencia",
      label: "Asistencia",
      options: {
        display: "excluded",  // Oculta en tabla, pero está disponible para exportar
        download: true,       // Incluye en CSV
      },
    },

  ];



  return (
    <>
      <div style={{ height: "calc(100vh - 80px )", width: "100%" }}>
        <div className="container mt-5">
          <Grid container spacing={2}>
            <Grid align="center" item xs={12} sm={12} md={12}>
              <h4>
                Hola  <b>{nombreProfesor}</b>, estos son tus
                talleres del trimestre.
              </h4>
              <hr></hr>
            </Grid>
          </Grid>
        </div>
        {state.loading ? (
          <div style={{ height: "calc(100vh - 80px)" }}>
            <span className="loader"></span>
          </div>
        ) : (
          <>
            <div className="table-container">
              <DataTable
                data={state.data}
                title={"Talleres"}
                columns={columns}
                displayColum={false}
                more={{
                  searchPlaceholder: "Buscar por Profesor"
                }}
              />
            </div>
          </>
        )}






        <Box
          sx={{
            "& > :not(style)": {
              display: "flex",
              justifyContent: "space-around",
              height: "100%",
              width: "100%",
            },
          }}
        >

          <div>
            <Collapse in={checked} sx={{ width: "100%" }}>
              <DataTable
                title={"Lista de alumnos"}
                data={state.alumnos}
                columns={columnsAlumnos}
                more={{
                  searchPlaceholder: "Buscar por Nombre",
                  customToolbar: () => (
                    <Button
                      variant="contained"
                      className={`${!checked ? "cta--guinda_disabled" : "cta--guinda"}`}
                      onClick={() => Descargar()}
                      startIcon={<ArrowCircleDownIcon />}
                    >
                      Descargar Lista
                    </Button>
                  ),
                }}
              />
            </Collapse>
          </div>
        </Box>
      </div>
    </>
  );
};

export default ProfesoresView;
